import gql from 'graphql-tag'

const REMOVE_INTEGRATION = gql`
  mutation RemoveIntegration($partnerName: PartnerName!) {
    removeIntegration(partnerName: $partnerName)
  }
`

const GET_INTEGRATIONS = gql`
  query GetIntegrations {
    getIntegrations {
      type
      status
      category
      stores {
        connected {
          id
          name
        }
        notConnected {
          id
          name
        }
      }
    }
  }
`

const CREATE_INTEGRATION = gql`
  mutation CreateIntegration($partnerName: PartnerName!) {
    createIntegration(partnerName: $partnerName)
  }
`

const GET_MERCHANT_INTEGRATION_SETTINGS = gql`
  query GetMerchantIntegrations {
    getMerchantIntegrations {
      lightspeedLoyaltyEnabled
      lightspeedLoyaltyPasswordSet
      lightspeedLoyaltyUsername
    }
  }
`

export {
  REMOVE_INTEGRATION,
  GET_INTEGRATIONS,
  CREATE_INTEGRATION,
  GET_MERCHANT_INTEGRATION_SETTINGS
}
